import 'favicon.ico'
import 'intl'
import 'intl/locale-data/jsonp/en'
import React from 'react'
import { createRoot } from 'react-dom/client'
import { share } from 'rxjs/operators'
import AppRouter from './shell/AppRouter'
import { RootStore } from 'RootStore'
import { LogRocketIntegration } from 'tracking/logrocket'
import { Env } from 'infra/env'
import { keyboardStream } from 'utils/keyboard-util'
import { pageActivityStream } from 'utils/dom-util'
import { ComicSansProtocol } from './ComicSansProtocol'
import {
  getFeatureToggleClient,
  identifyToggleClient,
  initializeToggleClient,
} from 'infra/featureToggles'
import { BoostrapTheming } from 'utils/theming'
import { HubspotIntegration } from 'tracking/hubspot'

const featureToggleClient = getFeatureToggleClient()

/**
 * initialize feature toggle client and
 * then render the app.
 */
initializeToggleClient(featureToggleClient)
  .then(() => undefined)
  .catch((err) =>
    console.error('Error initializing feature toggle client', err),
  )
  .finally(initApp)

function initApp() {
  const rootStore = new RootStore(
    () => new Date(),
    keyboardStream(window.document),
    pageActivityStream().pipe(share()),
  )

  const render = (Component: any) => {
    const root = createRoot(document.getElementById('work-portal')!)
    root.render(<Component rootStore={rootStore} />)
  }

  render(AppRouter)

  BoostrapTheming(rootStore.sessionStore.currentMember$).subscribe()

  identifyToggleClient(
    featureToggleClient,
    rootStore.sessionStore.currentUser$,
    rootStore.userDataStore.fetchByPublicId,
  ).subscribe()

  // Start Comic Sans Protocol
  ComicSansProtocol(rootStore.alertsController.newAlert)

  // ----

  // Don't want these in the root store as it's just vendor-specific side effects.

  // LogRocket integration.
  if (Env.LOGROCKET_KEY) {
    LogRocketIntegration(rootStore.sessionStore.currentMember$).subscribe()
  }

  // HubSpot integration.
  HubspotIntegration(
    rootStore.sessionStore.currentMember$,
    rootStore.freshbooksAPI.freshbooksHubspot,
    rootStore.authStore.token$,
    rootStore.userDataStore.getByPublicId,
  )
}
